import { WaffleFlag } from "@alch/dx-entities";
import { Button, Loading } from "@alch/ui";
import { Blast } from "@alch/ui/assets/logos";
import { AnimatedOnboarding } from "@components/ui";
import Onboarding1Video from "@features/blast/assets/onboarding-1.mp4";
import Onboarding2Video from "@features/blast/assets/onboarding-2.mp4";
import Onboarding3Video from "@features/blast/assets/onboarding-3.mp4";
import { useIsWaffleFlagEnabled } from "@queries/useWaffleFlags";
import { Path } from "@util/paths";
import { Url } from "@util/urls";
import { Redirect } from "react-router-dom";

const BLURB_ITEMS = [
  {
    title: "Only the basics",
    subtitle: "Core RPC",
    mediaUrl: Onboarding1Video,
  },
  {
    title: "Multi-region",
    subtitle: "High availability, low latencies",
    mediaUrl: Onboarding2Video,
  },
  {
    title: "5x lower cost",
    subtitle: "Suited for indexing and backfills",
    mediaUrl: Onboarding3Video,
  },
];

const BlastAppsEmptyState = () => {
  const isBlastFeatureEnabledFlag = useIsWaffleFlagEnabled(
    WaffleFlag.BlastFeature,
  );

  if (isBlastFeatureEnabledFlag.isPending) {
    return <Loading className="mx-auto my-20" />;
  }

  if (!isBlastFeatureEnabledFlag.data) {
    return <Redirect to={Path.Home} />;
  }

  return (
    <div className="mx-auto mt-20 max-w-[720px] rounded-2xl border border-primary bg-primary">
      <div className="flex flex-col items-center p-8 text-center">
        <img src={Blast} className="size-12" alt="Blast Logo" />

        <h1 className="pt-2 text-heading-h2 text-primary sm:text-heading-h1">
          Blast
        </h1>

        <p className="mt-2 text-secondary">
          Industry’s most affordable, historical Blockchain APIs
        </p>

        <a
          className="text-[#B25FF3] underline"
          href="https://www.alchemy.com/docs/reference/introduction-to-blast"
          target="_blank"
          rel="noreferrer"
        >
          Learn more about Blast API
        </a>

        <AnimatedOnboarding
          blurbs={BLURB_ITEMS}
          className="mt-8"
          blurbGradient="[border-image:linear-gradient(132.11deg,_#FF9C27,#FD48CE)_1]"
        />
      </div>

      <div className="border-t border-primary px-8 py-5">
        <Button
          size="lg"
          intent="secondary"
          className="mx-auto w-40"
          as="a"
          href={Url.ContactSales}
          target="_blank"
        >
          Talk to us
        </Button>
      </div>
    </div>
  );
};

export default BlastAppsEmptyState;
